import gql from 'graphql-tag';

const GET_COMMENT_FOR_DEVICE = gql`
  query getCommentForDevice($deviceSerialNo: String) {
    getCommentForDevice(deviceSerialNo: $deviceSerialNo) {
      code
      comment {
        deviceSerialNo
        createdBy
        updatedOn
        fromStage
        toStage
        imageAttachments
        _id
        creatorName
        note
        createdOn
      }
    }
  }
`;

export default GET_COMMENT_FOR_DEVICE;
